import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import packageJson from '../package.json'
import globalMixin from './globalMixin.js'
import OpenLayersMap from "vue3-openlayers";
import "vue3-openlayers/styles.css";

const app = createApp(App)

app.provide('wdm', { 
    'version' : packageJson.version,
    'system': '',
    'authenticated': false,
    'token': '',
    'upn':'',
    'username':'',
    'roles': [],
    'customerAbbreviations': {},
    'customerCoordinates' : {},
})

app.mixin(globalMixin) 
//createApp(App).use(router).mount('#app')
app.use(router)
app.use(OpenLayersMap)
app.mount('#app')

